import {EndpointBuilder} from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import {IActivity, IProfileActivity} from '../interfaces/activity';

export const type = 'activities';
export const activitiesEndpoints = (builder: EndpointBuilder<any, any, any>) => ({
  getActivities: builder.query<IActivity[], {username: string; startDate: string; endDate: string}>({
    query: ({username, startDate, endDate}) => ({
      url: `/activities/${username}/${startDate}/${endDate}`,
      method: 'GET'
    }),
    transformResponse: (response) =>
      Array.isArray(response)
        ? response.map((row, idx) => ({ ...row, id: idx + 1 }))
        : response
  }),
  getActivitiesDownload: builder.mutation<string, {username: string; startDate: string; endDate: string}>({
    query: ({username, startDate, endDate}) => ({
      url: `/activities/${username}/${startDate}/${endDate}/download`,
      method: 'GET'
    }),
    transformResponse: (response) =>
      Array.isArray(response)
        ? response.map((row, idx) => ({ ...row, id: idx + 1 }))
        : response
  }),
  getProfileActivities: builder.query<IProfileActivity, {username: string}>({
    query: ({username}) => ({
      url: `/profile/${username}`,
      method: 'GET'
    }),
    transformResponse: (response) =>
      Array.isArray(response)
        ? response.map((row, idx) => ({ ...row, id: idx + 1 }))
        : response
  })
});

export default activitiesEndpoints;
